import Cookies from "js-cookie";
import { useContext } from "react";
import { MenuContext } from "src/contexts/menu-context/MenuContext";
import { UserContext } from "src/contexts/UserContext";


//clear data
const useAAA = () => {

  const {clearAll}=useContext(UserContext)
  const { setNewTabItems, setNewTabContent, setTab } = useContext(MenuContext);
  const clearUserData= () =>{
  const darkThemeTemp = localStorage.getItem("darkTheme");
  localStorage.clear();
  localStorage.setItem("darkTheme", darkThemeTemp);
  setNewTabItems([]);
  setNewTabContent([]);
  setTab(null);
  clearAll();
  const allCookies = Cookies.get();
    for (const cookieName in allCookies) {
      Cookies.remove(cookieName);
    }


  
}


return { clearUserData};
}
export default useAAA;
//end of clear data
